const WhyChoose = () => {
    const features = [
        {
            id: 1,
            image: '/featureIcons/support.svg',
            title: "Support from Start to Finish",
            alt: "Support from Start to Finish",
            delay: "100",
        },
        {
            id: 2,
            image: '/featureIcons/discount.svg',
            title: "Unbeatable Prices",
            alt: "Unbeatable Prices",
            delay: "200",
        },
        {
            id: 3,
            image: '/featureIcons/quote-request.svg',
            title: "ATOL Protected",
            alt: "ATOL Protected",
            delay: "300",
        },
        {
            id: 4,
            image: '/featureIcons/booking.svg',
            title: "Flexible Bookings",
            alt: "Flexible Bookings",
            delay: "400",
        }
    ];

    return(
        <>
            <div className="container mx-auto px-0">
                <div className="flex justify-center text-center">
                    <div className="inline-block">
                        <h2 className="md:text-3xl text-2xl font-medium pt-7.5">Why Choose Halo Holidays for Your All Inclusive Holidays?</h2>
                        <p className="text-base leading-loose py-4">Your holiday should be as unique as you are. With unbeatable prices, flexible bookings, and round-the-clock support, we ensure your holiday experience is seamless and tailored to your preferences.</p>
                    </div>
                </div>
                <div className="flex flex-wrap justify-between pt-12.5 mb-7.5">
                    {features.map(feature => (
                        <div key={feature.id} className="w-full lg:w-1/4 sm:w-1/2 p-2.5" data-aos="fade" data-aos-delay={feature.delay}>
                            <div className="px-2.5 py-5 rounded-lg border hover:shadow-lg transition-shadow duration-300">
                                <div className="flex justify-center">
                                    <img alt={feature.alt} loading="lazy" width="50" height="30" decoding="async" className="lazy-load" src={feature.image} />
                                </div>
                                <div className="text-center mt-5">
                                    <h3 className="text-lg font-medium">{feature.title}</h3>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default WhyChoose;